import { useNavigate } from "react-router-dom";
import axios from "axios";
import API_URL from "../../config";

const useServiceNavigation = () => {
  const navigate = useNavigate();

  const handleServiceClick = async (serviceName, link) => {
    try {
      const response = await axios.post(`${API_URL}/layout/service`, {
        subservice: serviceName,
      });

      const imageUrl = response?.data?.data?.[0]?.image_url || "";
      console.log("service data in useServiceNavigation", response)

      navigate(link, { state: { serviceName, image: imageUrl } });
    } catch (error) {
      console.error("Error fetching image:", error);
    }
  };

  return { handleServiceClick };
};

export default useServiceNavigation;
